/**
 * Organisation terms and DPA acceptance. Dependency-free so node:test can
 * import it (see termsPolicy.test.js).
 *
 * The rule lives on the backend (backend/power_backend/agreements/services.py):
 * while a terms version is published, an admin of their own organisation whose
 * organisation has not accepted it gets `user.terms.acceptanceRequired` in the
 * session payload. Partner admins, site admins and everyone else are never
 * asked. OrgAccessGuard shows the acceptance page in place of the dashboard.
 */

export function needsTermsAcceptance(user) {
    return Boolean(user?.terms?.acceptanceRequired)
}

/** The message to show for a refused acceptance, from the API's error body. */
export function acceptErrorMessage(error) {
    const data = error?.response?.data
    if (typeof data?.detail === 'string') return data.detail
    for (const key of ['confirm', 'role', 'version']) {
        if (Array.isArray(data?.[key]) && data[key].length > 0) {
            return data[key][0]
        }
    }
    return 'Something went wrong. Please try again.'
}
